/* eslint-disable max-len */
import React, { FC } from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
import { LFC } from '../../../Legacy';
import { Button, Colors, Prompt } from '../../../ui';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';

const getColor = (props) => {
    if (props.isDragAccept) {
        return Colors.positive;
    }
    if (props.isDragReject) {
        return Colors.negative;
    }
    if (props.isDragActive) {
        return Colors.primary;
    }
    return Colors.active;
};

const DropFrame = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-width: .125rem;
  border-radius: .125rem;
  border-color: ${props => getColor(props)};
  border-style: dashed;
  background-color: #F6FAFD;
  color: ${Colors.textLight};
  outline: none;
  transition: border .24s ease-in-out;
`;

const DropZone: FC<{ maxFiles: number, onDrop: (files: File[]) => void }> = ({ maxFiles, onDrop }) => {

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({
        maxFiles,
        onDrop: files => onDrop(files),
    });

    return <DropFrame {...getRootProps({ isDragActive, isDragAccept, isDragReject })}>
        <input {...getInputProps()} />
        <p>Drag &amp; drop your file here, or click to select files.</p>
        <br />
        <Button variant="primary">Browse...</Button>
    </DropFrame>;
};

export const importDataViaLanguageModelPopup = () => ({ ui: ImportDataViaLanguageModelPopup, droppable: true });

export const ImportDataViaLanguageModelPopup: LFC<PopupProps> = ({ action, dismiss }) =>
    <Prompt ignoreEnter onAction={dismiss}>
        <Popup w={48} h={36}>
            <Popup.Close onAction={dismiss} />
            <Popup.Header>
                <Popup.Title>Drop Your File Here</Popup.Title>
                <Popup.SubTitle>Dawg</Popup.SubTitle>
            </Popup.Header>
            <Flexer height="1"></Flexer>
            <Popup.Content>
                <DropZone maxFiles={1} onDrop={files => action(files[0])} />
            </Popup.Content>
            <Popup.Actions>
                <Button onAction={dismiss}>Close</Button>
            </Popup.Actions>
        </Popup>
    </Prompt>;


